<template>
   <div class="auth-box login-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
         <!-- Start col -->
         <div class="col-md-6 col-lg-5">
            <!-- Start Auth Box -->
            <div class="auth-box-right">
                  <div class="card">
                     <div class="card-body">
                        <form id="login-form" @submit.prevent="sendForm">
                           <div class="form-head">
                              <img :src="mainLogo" class="img-fluid" alt="logo">
                           </div>
                           <h4 class="text-primary my-4">Ingrese con su cuenta</h4>

						         <alert color="danger" v-if="errorMssg">{{errorMssg}}</alert>

                           <div class="form-group">
                              <input v-model="form.username" type="text" class="form-control" placeholder="Número de cliente" required>
                           </div>
                           <div class="form-group">
                              <input v-model="form.password" type="password" class="form-control" placeholder="Contraseña" required>
                           </div>
                           <div class="form-row mb-3">
                              <!--div class="col-sm-12">
                                 <div class="forgot-psw"> 
                                    <router-link :to="{name: 'recuperar-contrasena'}">¿Olvidó su contraseña?</router-link>
                                 </div>
                              </div-->
                           </div>
                           <button type="submit" class="btn btn-success btn-lg btn-block font-18" :disabled="isLoading">
                              <span class="spinner-border spinner-border-sm spinner-btn-lg" role="status" aria-hidden="true" v-if="isLoading"></span>
                              {{isLoading ? 'Cargando...' : 'Enviar'}}
                           </button>
                        </form>
                     </div>
                  </div>
            </div>
            <!-- End Auth Box -->
         </div>
         <!-- End col -->
      </div>
      <!-- End row -->
   </div>
</template>

<script>
import {mapMutations} from "vuex";
export default {
  name: 'Login',
  data(){
    return {
      mainLogo: require('@assets/images/logos/mid-logo.png'),
		isLoading: false,
		errorMssg: null,
      form: {
         username: null,
         password: null,
      }
    }
  },
  methods: {
		...mapMutations('auth', ['setUser', 'setSpecialCustomerValue', 'setStateAccessToken', 'setLoadCSF']),
      ...mapMutations('general', ['setGeneralInfo']),
   	async sendForm(){
			this.errorMssg = null;
			if(!this.validateForm()){
				this.errorMssg = "Complete todos los campos.";
				return false;
			}
         this.isLoading = true;

         let payload = {Username: this.form.username, Password: this.form.password};
         const res = await this.xpost('/login', payload);
         if(res.success){

            this.setUser(res.data.cliente);
            this.setSpecialCustomerValue(res.data.negocio_especial)           
            if(res.data.load.length > 0){
               this.setLoadCSF(true);
            }
            else{
               this.setLoadCSF(false);
            } 
            const access_token = res.data.token;
            this.setStateAccessToken(access_token);
            this.setAxiosAccessToken(access_token);

            // solicitar informacion general
            await this.requestGeneralInfo();

            // ir a la vista principal de la interfaz
            await this.$router.replace({name: 'cliente-comprar'});
         }
         else {
            this.errorMssg = res.error;
         }
         this.isLoading = false;
      },
      setAxiosAccessToken(token){
         window.axios.defaults.headers.common['X-AUTH-TOKEN'] = token;
      },
      async requestGeneralInfo(){
         const res = await this.xget('/info_general');
         if(res.success){
            this.setGeneralInfo(res.data);
         }
      },
		validateForm(){
			return this.form.username != null && this.form.password != null;
		},		
  },
}
</script>
